import {useCallback} from 'react';

import useSubmitReturnDetailsCollectionSessionMutation from 'src/return/api/useSubmitReturnDetailsCollectionSessionMutation';
import type {ReturnDetailsCollectionSessionCredentials} from 'src/return/state/useReturnDetailsCollectionContext';

type SubmitReturnDetailsCollectionSessionCredentials = Pick<
  ReturnDetailsCollectionSessionCredentials,
  'clientSecret' | 'sessionId'
>;

export const useSubmitReturnDetailsCollectionSession = (
  credentials: SubmitReturnDetailsCollectionSessionCredentials,
) => {
  const [submitMutation, {loading}] =
    useSubmitReturnDetailsCollectionSessionMutation();

  const submit = useCallback(
    async (returnAddress: string) => {
      const result = await submitMutation({
        variables: {
          input: {
            client_secret: credentials.clientSecret,
            return_address: returnAddress.trim(),
            return_details_collection_session: credentials.sessionId,
          },
        },
      });

      if (result.error) {
        throw result.error;
      }

      const collectionSession =
        result.data
          ?.v1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSessionSubmit;

      if (!collectionSession) {
        throw new Error('Failed to submit return details collection session');
      }

      return collectionSession;
    },
    [credentials.clientSecret, credentials.sessionId, submitMutation],
  );

  return [submit, {loading}] as const;
};
